// Remove href attribute from <a> that links to image URL and has image child
export const isURLToImage = (url: string) => url.match(/.(jpeg|jpg|gif|png|webp)$/) != null;
export default () => {
  const checkIfChildrenContainImg = (elem: Element) => {
    for (let i = 0, length = elem.children.length; i < length; i++) {
      if (elem.children[i].tagName === 'IMG') {
        return true;
      }
      if (checkIfChildrenContainImg(elem.children[i])) {
        return true;
      }
    }
    return false;
  };

  const aElements = document.getElementsByTagName('a');

  // Look for a href attributes ending with image extensions
  const aElementsWithHrefToImg = [];
  for (let i = 0, length = aElements.length; i < length; i++) {
    if (aElements[i].href && isURLToImage(aElements[i].href)) {
      aElementsWithHrefToImg.push(aElements[i]);
    }
  }

  aElementsWithHrefToImg.forEach((aElem) => {
    if (checkIfChildrenContainImg(aElem)) {
      aElem.removeAttribute('href');
    }
  });
};
